const decode = (str: string) => {
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
};

export const parseCookie = (cookies: string) => {
  const obj = Object.create(null) as Record<string, string | undefined>;
  const list = cookies.split(';');

  list.forEach((cookie: string) => {
    if (cookie === '') {
      return;
    }

    const eq = cookie.indexOf('=');
    const key = (eq > 0 ? cookie.slice(0, eq) : cookie).trim();
    const value = eq > 0 ? decode(cookie.slice(eq + 1).trim()) : undefined;

    if (!(key in obj)) {
      obj[key] = value;
    }
  });

  return obj;
};
